var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dash-meeting-agenda__list-item" },
    [
      _c(
        "router-link",
        { staticClass: "dash-meeting-agenda__link", attrs: { to: _vm.link } },
        [
          _c("div", { staticClass: "grid" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid__col--1 dash-meeting-agenda__icon h-center-align"
              },
              [
                _c("i", {
                  staticClass: "fa fa-calendar-day meeting-agenda__link-icon"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid__col--2 dash-meeting-agenda__date h-center-align"
              },
              [_vm._v(_vm._s(_vm.agenda.meeting_date))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid__col--9 dash-meeting-agenda__name" },
              [_vm._v(_vm._s(_vm.agenda.title))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }